import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { grey } from "@mui/material/colors";
import { useState } from "react";
import { misc } from "app/themes/colors";
import Box from "@mui/material/Box";

type SortCellHeaderProps = {
  orderingField?: string;
  orderingValue?: string;
  label: string;
  onToggleSortChange?: (field: string | undefined) => void;
};
export default function SortCellHeader({
  orderingField,
  orderingValue,
  label,
  onToggleSortChange,
}: SortCellHeaderProps) {
  const [showIconButton, setShowIconButton] = useState(false);

  const handleChangeSortDirection = () => {
    onToggleSortChange?.(orderingField);
  };

  const sortDirection =
    !orderingValue || !(orderingValue ?? "").includes(orderingField ?? "")
      ? undefined
      : orderingValue.startsWith("-")
      ? "desc"
      : "asc";

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      width="fit-content"
      columnGap={0.25}
      sx={{ cursor: "pointer" }}
      onClick={handleChangeSortDirection}
      onMouseEnter={() => {
        if (!sortDirection) {
          setShowIconButton(true);
        }
      }}
      onMouseLeave={() => {
        setShowIconButton(false);
      }}
    >
      <Typography
        sx={{
          whiteSpace: "normal",
          lineHeight: "normal",
          textTransform: "uppercase",
          letterSpacing: 0.7,
          fontSize: "14px",
          fontWeight: 700,
          borderBottom: `dotted 1px ${grey[700]}`,
          color: sortDirection ? misc.sunoGreen : undefined,
        }}
      >
        {label}
      </Typography>
      <IconButton
        size="small"
        sx={{
          color: grey[700],
          "&:hover": {
            color: grey[900],
          },
        }}
      >
        {sortDirection === "asc" && (
          <ArrowUpwardIcon sx={{ fontSize: "18px" }} />
        )}
        {sortDirection === "desc" && (
          <ArrowDownwardIcon sx={{ fontSize: "18px" }} />
        )}
        {!sortDirection && showIconButton && (
          <ArrowUpwardIcon sx={{ fontSize: "18px" }} />
        )}
        {!sortDirection && !showIconButton && (
          <Box width="28px" height="28px" />
        )}
      </IconButton>
    </Stack>
  );
}
